import { render, staticRenderFns } from "./CreateParticipantForm.vue?vue&type=template&id=632384a2"
import script from "./CreateParticipantForm.vue?vue&type=script&lang=ts"
export * from "./CreateParticipantForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateParticipantForm.vue?vue&type=style&index=0&id=632384a2&prod&lang=css"
import style1 from "./CreateParticipantForm.vue?vue&type=style&index=1&id=632384a2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports